export const GET_LIST_NOTIFICATION = 'GET_LIST_NOTIFICATION';
export const GET_LIST_NOTIFICATION_DONE = 'GET_LIST_NOTIFICATION_DONE';

export const GET_COUNT_TOTAL_NOTIFICATION = 'GET_COUNT_TOTAL_NOTIFICATION';
export const GET_COUNT_TOTAL_NOTIFICATION_DONE = 'GET_COUNT_TOTAL_NOTIFICATION_DONE';

export const UPDATE_STATUS_NOTIFICATION = 'UPDATE_STATUS_NOTIFICATION';

export const GET_DETAIL_NOTIFICATION = 'GET_DETAIL_NOTIFICATION';